import React, { useContext, useState } from 'react';
import { DataContext } from '../context/data-context';
import { useSeasons } from '../hooks/seasons';

export default function StatsSeasonSelector() {
  const { currentSeason } = useContext(DataContext);
  const [s ,setSeason] = useState(currentSeason);
  const [seasons, loadingSeasons, errorSeasons] = useSeasons('desc');

  const onSelect = (selectedSeason) => {
    window.location.replace(`/tabell/${selectedSeason}`);
  };

  return (
    <section className="row">
      <div className="col-12 col-md-4 offset-md-8 mb-3">
        <p className="heading-h6 mb-1">Säsong</p>
        <select
          className="select"
          value={s}
          onChange={(e) => onSelect(e.target.value)}
        >
          {seasons?.map((season) => (
            <option>{season?.configSeasonStartYear}</option>
          ))}
        </select>
      </div>
    </section>
  );
}
